import { useQuery } from "react-query";
import { ProductsListQueryID } from "./hooksConstants";

import apiClient from "@/services/apiClient";

const useProductList = (subscriptionOnly?: boolean) =>  useQuery([ProductsListQueryID], async () => {
    const [productsList, _status] = await apiClient.productList(subscriptionOnly);
    return productsList;
}) ;

export default useProductList;